import { render, staticRenderFns } from "./SrAgreementAmendmentForm.vue?vue&type=template&id=95957692&"
import script from "./SrAgreementAmendmentForm.vue?vue&type=script&lang=js&"
export * from "./SrAgreementAmendmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports